<div
  class="card stat-card"
  [class.roadmap-stat]="data?.styleVariant === 'roadmap'"
  [class.audit-stat]="data?.styleVariant === 'survey-audit'"
  [class.warning]="data?.variant === 'warning'"
  [ngStyle]="{ 'background-color': data.bgColor }"
  height="20px"
>
  <div class="card-content">
    <mat-icon *ngIf="data?.icon" class="stat-icon">{{ data.icon }}</mat-icon>
    <div class="card-title" [innerHTML]="formattedTitle"></div>
    <div class="card-value">{{ stat }} {{data.suffix}}</div>
    <div *ngIf="data?.delta" class="card-delta">{{ data.delta }}</div>
    <div *ngIf="data?.badge" class="card-badge">{{ data.badge }}</div>
  </div>
</div>
